export default "__VITE_ASSET__cec2e445__"